export const labelStyle = {
  flex: "0 0 40%",
  maxWidth: "40%",
};

export const inputStyle = {
  flex: "0 0 60%",
  maxWidth: "60%",
};
